var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.6662H16.5M12.75 1.9162C13.0815 1.58468 13.5312 1.39844 14 1.39844C14.2321 1.39844 14.462 1.44416 14.6765 1.533C14.891 1.62184 15.0858 1.75205 15.25 1.9162C15.4142 2.08036 15.5444 2.27523 15.6332 2.48971C15.722 2.70418 15.7678 2.93406 15.7678 3.1662C15.7678 3.39835 15.722 3.62822 15.6332 3.8427C15.5444 4.05718 15.4142 4.25205 15.25 4.4162L4.83333 14.8329L1.5 15.6662L2.33333 12.3329L12.75 1.9162Z",
    stroke: "#150823",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserIcon);
export default __webpack_public_path__ + "static/media/edit-user-icon.999bdcc3b2fcd59f4f560d4964898228.svg";
export { ForwardRef as ReactComponent };